import { isMobile } from "./is-mobile";

export const addClickHandler = (
  handler: React.TouchEventHandler | React.MouseEventHandler
) => {
  return isMobile
    ? { onTouchStart: handler as React.TouchEventHandler }
    : { onClick: handler as React.MouseEventHandler };
};
